/** Class representing a policy validation error
 *  @extends Error
 */

const FILE_TYPE_VIOLATION = 'type';
const FILE_SIZE_VIOLATION = 'size';

export default class PolicyValidationError extends Error {
    /**
     * Create a policyValidationError
     * @param {string} statusText
     * @param {string} info
     * @param {string} type
     * @param {string} policy
     */
    constructor(statusText, info, type, policy) {
        super(statusText);
        this.info = info;
        this.type = type;
        this.policy = policy;
    }

    static get types() {
        return {
            FILE_TYPE_VIOLATION,
            FILE_SIZE_VIOLATION
        };
    }
}
